import { useContext, useState, useEffect, useRef, useCallback } from 'react';
import Modal from 'react-bootstrap/Modal';
import DataContext from '../context';
import Skeleton from 'react-loading-skeleton';
import { ApiService } from '../services/apiServices';
import { toast } from 'react-toastify'
import Loader from "react-js-loader";
import sessionCartData from '../Element/cart_session_data';
function ApplyCoupanModal() {
    const timeZone = "Australia/Sydney";
    const [cart, setCart] = useState(() => {
        return JSON.parse(localStorage.getItem('CART_SESSION')) || [];
    });

    const contextValues = useContext(DataContext)
    const dataArray = sessionCartData()
    const cartSummary = dataArray[3]
    const didMountRef = useRef(true)
    const [isLoader, setIsLoader] = useState(true);
    const [couponsList, setCouponsList] = useState(true);
    const [promoCode, setPromoCode] = useState("");
    const [proccessLoader, setProccessLoader] = useState(false);
    const getCouponsListData = useCallback(async () => {
        try {
            const res = await ApiService.fetchData('couponsList');
            if (res.status === 'success') {
                setCouponsList(res.allCouponsData)
            }
        } catch (error) {
            console.error('Error fetching available slot date-time data:', error);
        } finally {
            setIsLoader(false);
        }
    }, []);

    useEffect(() => {
        if (didMountRef.current) {
            if (localStorage.getItem("USER_TOKEN")) {
                getCouponsListData();
            }
        }
        didMountRef.current = false;
    }, [getCouponsListData]);

    const onTodoChange = (e) => {
        const { value } = e.target;
        setPromoCode(value);
    };

    const applyCoupon = async (coupon) => {
        if (coupon == '') {
            toast.error("Please enter Coupon Code");
            return false;
        }
        const productData = {
            promo_code: coupon,
            cart_total: cartSummary.sellingTotal,
            order_type: contextValues.orderRecieveStatus,
            store_id: contextValues.selectedStore && contextValues.selectedStore.store_id > 0 ? contextValues.selectedStore.store_id : 0
        };
        setProccessLoader(true)
        ApiService.postData("selectCouponNew", productData).then(async (res) => {
            if (res.data.status === 'success') {
                if (res.data.itemsData) {
                    const isValid = await onModalOpen(res.data.itemsData);
                    if (isValid) {
                        toast.success(res.data.notification)
                        localStorage.removeItem("COUPON_SESSION");
                        const couponSessionObj = {
                            discount_amount: res.data.itemsData.product_selling_price,
                            promo_id: res.data.promo_id,
                            promo_code: res.data.promo_code,
                            free_item: res.data.itemsData.product_id,
                        };
                        localStorage.setItem("COUPON_SESSION", JSON.stringify(couponSessionObj));
                        contextValues.setSelectedCoupon(couponSessionObj);
                        setProccessLoader(false)
                        applyModal()
                    } else {
                        toast.error('Coupon is invalid, Please try another')
                        setProccessLoader(false)
                    }
                } else {
                    toast.success(res.data.notification)
                    localStorage.removeItem("COUPON_SESSION");
                    const couponSessionObj = {
                        discount_amount: res.data.discount_amount,
                        promo_id: res.data.promo_id,
                        promo_code: res.data.promo_code,
                        free_item: 0,
                    };
                    localStorage.setItem("COUPON_SESSION", JSON.stringify(couponSessionObj));
                    contextValues.setSelectedCoupon(couponSessionObj);
                    setProccessLoader(false)
                    applyModal()
                }
            } else if (res.data.status === "session_out") {
                localStorage.removeItem('USER_TOKEN')
                window.location.href = '/'
            } else {
                toast.error(res.data.notification)
                setProccessLoader(false)
            }
        }).catch((error) => {
            toast.error(error)
            setProccessLoader(false)
        });
    }

    const applyModal = () => {
        contextValues.setToggleApplyCoupanModal(!contextValues.toggleapplycoupanModal)
    }

    const onModalOpen = async (item) => {
        const cart = JSON.parse(localStorage.getItem('CART_SESSION')) || []
        if (item.product_type === 0) {
            const existingItem = cart.find(cartItem => cartItem.product_id === item.product_id);
            let updatedCart;
            if (existingItem) {
                updatedCart = cart.map(cartItem =>
                    cartItem.product_id === item.product_id
                        ? { ...cartItem, quantity: cartItem.quantity}
                        : cartItem
                );
                updateCartInSession(updatedCart);
                return true;
            }
        }
        return false;
    };

    const updateCartInSession = (updatedCart) => {
        localStorage.removeItem("CART_SESSION");
        localStorage.removeItem("COUPON_SESSION");
        localStorage.setItem('CART_SESSION', JSON.stringify(updatedCart));
        contextValues.setCartSessionData(updatedCart)
        contextValues.setCartCount(updatedCart.length)
        setCart(updatedCart);
    };

    return (<>
        <Modal className='couponsModal ' show={contextValues.toggleapplycoupanModal} onHide={(e) => applyModal()} backdrop="static">
            <div className="couponsModal-header">
                <h5 className="mb-0">Apply Coupons</h5>
                <button type="button" className="couponsModal-close" onClick={() => { applyModal() }}><i className="ri-close-line"></i></button>
            </div>
            <div className="couponModal-search">
                <input type="text" placeholder="Enter Coupon Code" name="promo_code" value={promoCode} onChange={(e) => onTodoChange(e)} />
                <button className="lmc-apply" onClick={(e) => applyCoupon(promoCode)}>CHECK</button>
            </div>
            {proccessLoader && <div className="pageLoder"><Loader type="spinner-cub" bgColor={'#db2727'} color={'#db2727'} size={50} /></div>}
            {isLoader ?
                <div className="apply-coupons-list">
                    <ul>
                        {Array.from({ length: 3 }).map((_, index) => {
                            return (
                                <li key={index}>
                                    <div className="aclbox">
                                        <Skeleton width={100} height={25} />
                                        <div className="aclbox-desc"><Skeleton width={250} height={15} /></div>
                                        <div className="aclbox-apply"><Skeleton width={50} height={15} /></div>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                </div>
                :
                couponsList && couponsList.length > 0 &&
                <div className="apply-coupons-list">
                    <ul>
                        {couponsList && couponsList.length > 0 && couponsList.map((couponValue, index) => {
                            return (
                                <li key={index}>
                                    <div className="aclbox">
                                        <div className="aclbox-coupon">{couponValue.promo_coupon_code}</div>
                                        <div className="aclbox-desc">{couponValue.promo_description}</div>
                                        <div className="aclbox-apply" onClick={(e) => applyCoupon(couponValue.promo_coupon_code)}>Apply</div>
                                    </div>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            }
        </Modal>
    </>)
}

export default ApplyCoupanModal